import React from 'react';
const TravelSeasons = () => {
  const seasons = [{
    season: 'Spring (March-May)',
    destinations: [{
      name: 'Turkey',
      description: 'Pleasant temperatures, blooming flowers, and fewer crowds make spring an ideal time to visit Istanbul and Cappadocia.',
      image: 'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80'
    }, {
      name: 'Europe',
      description: 'Spring in Europe brings mild weather and beautiful gardens in bloom, perfect for city explorations before the summer crowds arrive.',
      image: 'https://images.unsplash.com/photo-1503917988258-f87a78e3c995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80'
    }]
  }, {
    season: 'Summer (June-August)',
    destinations: [{
      name: 'Maldives',
      description: "While summer brings some rain, it's also low season with great deals and still plenty of sunshine between showers.",
      image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1965&q=80'
    }, {
      name: 'Malaysia',
      description: 'The west coast of Malaysia enjoys drier weather during summer, making it perfect for beach holidays in Langkawi and Penang.',
      image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1164&q=80'
    }]
  }, {
    season: 'Fall (September-November)',
    destinations: [{
      name: 'Dubai',
      description: 'As temperatures cool down from the extreme summer heat, fall is an excellent time to visit Dubai for outdoor activities.',
      image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'
    }, {
      name: 'Thailand',
      description: 'The rainy season ends and cooler temperatures arrive, making it a great time to visit before the peak tourist season begins.',
      image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'
    }]
  }, {
    season: 'Winter (December-February)',
    destinations: [{
      name: 'Thailand',
      description: 'Winter brings dry and sunny weather to Thailand, perfect for beach holidays and exploring temples without rain.',
      image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80'
    }, {
      name: 'Dubai',
      description: 'Mild temperatures make winter the peak season for Dubai, ideal for sightseeing, desert safaris, and outdoor activities.',
      image: 'https://images.unsplash.com/photo-1546412414-e1885259563a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80'
    }]
  }];
  return <section className="py-16 bg-white" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <div className="text-center mb-12" data-id="element-257">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-258">
            Best Seasons to Travel
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-259">
            Timing is everything when planning your perfect getaway. Here's our
            guide to the best seasons to visit our popular destinations for
            optimal weather and experiences.
          </p>
        </div>
        <div className="space-y-12" data-id="element-260">
          {seasons.map((season, index) => <div key={index} data-id="element-261">
              <h3 className="text-2xl font-semibold text-gray-900 mb-6 pb-2 border-b border-gray-200" data-id="element-262">
                {season.season}
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-263">
                {season.destinations.map((destination, idx) => <div key={idx} className="flex flex-col md:flex-row gap-6 bg-gray-50 rounded-lg overflow-hidden shadow-md" data-id="element-264">
                    <div className="md:w-2/5" data-id="element-265">
                      <img src={destination.image} alt={destination.name} className="w-full h-full object-cover" data-id="element-266" />
                    </div>
                    <div className="p-6 md:w-3/5" data-id="element-267">
                      <h4 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-268">
                        {destination.name}
                      </h4>
                      <p className="text-gray-700" data-id="element-269">{destination.description}</p>
                    </div>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TravelSeasons;